import FixedNav from "../components/Nav/FixedNav";
import MobileNav from "../components/Nav/MobileNav";
import Header from "../components/Description/Header";
import Title from "../components/Description/Title";
import Normal from "../components/Description/Normal";
import Big from "../components/Description/Big";

const Privacy = () => {
  return (
    <div id="body">
      <div className="framer-IqNBt framer-vrYYp framer-NrkXy framer-l50WH framer-V74Ls framer-uKIIJ framer-Fw2Wf framer-72rtr7 min-h-screen !w-auto">
        <FixedNav />
        <MobileNav />
        <div id="content" className="w-full mt-[60px] p-[20px]">
          <Header>Codeblaze Privacy Policy</Header>
          <Normal>Last Updated: July 3, 2025</Normal>
          <div className="p-10" />

          <Title>Introduction</Title>
          <div className="p-3" />
          <Normal>
            This privacy policy explains how Codeblaze AI Incorporated ("Codeblaze," "we," or "us") collects, uses, and protects your information when you use our website (codeblaze.ai) and services. This policy applies to all users of our platform and services and should be read in conjunction with our Terms of Service, which contain additional important information about how we handle your data and content.
          </Normal>
          <div className="p-5" />

          <Title>Data Collection and Use</Title>
          <div className="p-3" />
          <Big>Information We Collect</Big>
          <div className="p-3" />

          <Big>Account Information</Big>
          <div className="p-3" />
          <Normal>
            - Email address
            <br />- Name
            <br />- Payment information for paid plans
            <br />- Account preferences and settings
          </Normal>
          <div className="p-3" />

          <Big>Service Usage Data</Big>
          <div className="p-3" />
          <Normal>
            - Generated code and prompts
            <br />- Platform interaction data
            <br />- Feature usage statistics
            <br />- Error logs and debugging information
          </Normal>
          <div className="p-3" />

          <Big>Automatically Collected Information</Big>
          <div className="p-3" />
          <Normal>
            - IP addresses
            <br />- Browser type and version
            <br />- Device information
            <br />- Operating system
            <br />- Access times and dates
            <br />- Pages visited
          </Normal>
          <div className="p-5" />

          <Big>Analytics and Tracking</Big>
          <div className="p-3" />
          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-300">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 px-4 py-2 text-left">Tool</th>
                  <th className="border border-gray-300 px-4 py-2 text-left">Purpose</th>
                  <th className="border border-gray-300 px-4 py-2 text-left">More Information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-300 px-4 py-2 text-white">PostHog</td>
                  <td className="border border-gray-300 px-4 py-2 text-white">Product analytics and user behavior tracking</td>
                  <td className="border border-gray-300 px-4 py-2 text-white">PostHog Privacy Policy</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-2 text-white">Google Analytics</td>
                  <td className="border border-gray-300 px-4 py-2 text-white">Understanding website traffic and usage</td>
                  <td className="border border-gray-300 px-4 py-2 text-white">Google Analytics Opt-out, Google's Privacy & Terms</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="p-3" />

          <Big>Cookies and Tracking Technologies</Big>
          <div className="p-3" />
          <Normal>
            We use cookies and similar tracking technologies to:
            <br />- Maintain your session
            <br />- Remember your preferences
            <br />- Analyze platform usage
            <br />- Improve our services
          </Normal>
          <div className="p-3" />
          <Normal>
            You can control cookie preferences through your browser settings.
          </Normal>
          <div className="p-5" />

          <Title>How We Use Your Information</Title>
          <div className="p-3" />
          <Normal>
            We use collected information as detailed in our Terms of Service for the following purposes:
          </Normal>
          <div className="p-3" />

          <Big>Service Provision and Improvement</Big>
          <div className="p-3" />
          <Normal>
            - Platform functionality improvements
            <br />- AI model training (except for Enterprise plan users)
            <br />- Service quality enhancements
          </Normal>
          <div className="p-3" />

          <Big>Support and Operations</Big>
          <div className="p-3" />
          <Normal>
            - Customer support
            <br />- Payment processing
            <br />- Service updates
          </Normal>
          <div className="p-3" />

          <Big>Security and Maintenance</Big>
          <div className="p-3" />
          <Normal>
            - Platform security maintenance
            <br />- Usage pattern analysis
            <br />- Technical issue debugging
            <br />- Abuse and fraud prevention
          </Normal>
          <div className="p-5" />

          <Title>Data Sharing and Processing</Title>
          <div className="p-3" />
          <Big>Third-party Service Providers</Big>
          <div className="p-3" />
          <Normal>
            We share data with trusted service providers as outlined in our Terms. For specific information about:
            <br />- Data processing practices
            <br />- Enterprise plan protections
            <br />- Service provider requirements
            <br />- Custom handling agreements
          </Normal>
          <div className="p-3" />

          <Big>Enterprise Plan Users</Big>
          <div className="p-3" />
          <Normal>
            Enterprise users enjoy additional data protection and privacy rights. For complete details about:
            <br />- Data training restrictions
            <br />- Custom agreements
            <br />- Third-party sharing limitations
          </Normal>
          <div className="p-5" />

          <Title>Your Rights</Title>
          <div className="p-3" />
          <Normal>
            You have the right to:
            <br />- Access your personal data
            <br />- Request data correction
            <br />- Request data deletion
            <br />- Export your data
            <br />- Opt out of certain processing
            <br />- Withdraw consent
          </Normal>
          <div className="p-3" />
          <Normal>
            Contact privacy@codeblaze.ai to exercise these rights.
          </Normal>
          <div className="p-5" />

          <Title>Security Measures</Title>
          <div className="p-3" />
          <Normal>
            We implement industry-standard security measures:
            <br />- Encrypted data transmission
            <br />- Secure data storage
            <br />- Access controls
            <br />- Regular security audits
            <br />- Employee training
          </Normal>
          <div className="p-5" />

          <Title>Service Improvements and AI Training</Title>
          <div className="p-3" />
          <Normal>
            As detailed in the "Data Usage, Training, and Learning" section of our Terms, we may use certain data to improve our services and train our AI systems. Important exceptions and limitations apply, particularly for Enterprise users.
          </Normal>
          <div className="p-5" />

          <Title>User Content Visibility</Title>
          <div className="p-3" />
          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-300">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 px-4 py-2 text-left">Content Type</th>
                  <th className="border border-gray-300 px-4 py-2 text-left">Visibility</th>
                  <th className="border border-gray-300 px-4 py-2 text-left">Access</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-300 px-4 py-2 text-white">Private Content</td>
                  <td className="border border-gray-300 px-4 py-2 text-white">Only accessible to you and Codeblaze's authorized personnel</td>
                  <td className="border border-gray-300 px-4 py-2 text-white">Used to provide support and maintain platform functionality</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-2 text-white">Public Projects</td>
                  <td className="border border-gray-300 px-4 py-2 text-white">Visible to other users</td>
                  <td className="border border-gray-300 px-4 py-2 text-white">Can be remixed and used as starting points for other projects</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-2 text-white">Private Projects</td>
                  <td className="border border-gray-300 px-4 py-2 text-white">Not visible to others</td>
                  <td className="border border-gray-300 px-4 py-2 text-white">Not remixable</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="p-5" />

          <Title>Liability Protections</Title>
          <div className="p-3" />
          <Normal>
            1. We cannot be held liable for issues arising from users deliberately circumventing our platform limitations or protections to access private content.
            <br />2. Users are responsible for maintaining the confidentiality of their account information and for all activities that occur under their account.
            <br />3. We disclaim all liability for any damages, loss of profits, or other harm resulting from unauthorized access to user content.
          </Normal>
          <div className="p-5" />

          <Title>Children's Privacy</Title>
          <div className="p-3" />
          <Normal>
            Our services are not intended for users under 18. We do not knowingly collect data from children.
          </Normal>
          <div className="p-5" />

          <Title>International Data Transfers</Title>
          <div className="p-3" />
          <Normal>
            We may transfer data internationally within our service provider network. We ensure appropriate safeguards are in place for these transfers.
          </Normal>
          <div className="p-5" />

          <Title>Legal Framework</Title>
          <div className="p-3" />
          <Normal>
            This privacy policy is part of and subject to our Terms of Service. In case of any conflict between this privacy policy and our Terms, the Terms shall prevail.
          </Normal>
          <div className="p-5" />

          <Title>Changes to This Policy</Title>
          <div className="p-3" />
          <Normal>
            We may update this policy periodically. Changes will be handled in accordance with the process outlined in our Terms of Service regarding policy updates.
          </Normal>
          <div className="p-5" />

          <Title>Contact Details</Title>
          <div className="p-3" />
          <Big>General Contact Information</Big>
          <div className="p-3" />
          <Normal>
            <strong>Company name:</strong> Codeblaze AI Incorporated
            <br /><strong>Address:</strong> Dover, DE 19904, USA
            <br /><strong>Website:</strong> https://codeblaze.ai
          </Normal>
          <div className="p-5" />

          <Big>Contact Us For</Big>
          <div className="p-3" />
          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-300">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 px-4 py-2 text-left">Purpose</th>
                  <th className="border border-gray-300 px-4 py-2 text-left">Email Address</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-300 px-4 py-2 text-white">Privacy questions</td>
                  <td className="border border-gray-300 px-4 py-2 text-white">privacy@codeblaze.ai</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-2 text-white">Support (Enterprise & Scale plans)</td>
                  <td className="border border-gray-300 px-4 py-2 text-white">support@codeblaze.ai</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-2 text-white">DMCA and legal issues</td>
                  <td className="border border-gray-300 px-4 py-2 text-white">legal@codeblaze.ai</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-2 text-white">General feedback</td>
                  <td className="border border-gray-300 px-4 py-2 text-white">feedback@codeblaze.ai</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-2 text-white">Job applications</td>
                  <td className="border border-gray-300 px-4 py-2 text-white">careers@codeblaze.ai</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="p-5" />

          <Big>Response Times</Big>
          <div className="p-3" />
          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-300">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 px-4 py-2 text-left">Inquiry Type</th>
                  <th className="border border-gray-300 px-4 py-2 text-left">Response Time</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-300 px-4 py-2 text-white">Privacy-related inquiries</td>
                  <td className="border border-gray-300 px-4 py-2 text-white">Within 7 business days</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-2 text-white">Support requests</td>
                  <td className="border border-gray-300 px-4 py-2 text-white">According to your plan's service level agreement</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-2 text-white">Urgent matters (data protection/security incidents)</td>
                  <td className="border border-gray-300 px-4 py-2 text-white">Please mark your email as "URGENT - Privacy concern"</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="p-5" />

          <Big>Additional Resources</Big>
          <div className="p-3" />
          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-300">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 px-4 py-2 text-left">Resource</th>
                  <th className="border border-gray-300 px-4 py-2 text-left">Link</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-300 px-4 py-2 text-white">Terms of Service</td>
                  <td className="border border-gray-300 px-4 py-2 text-white">https://codeblaze.ai/terms</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-2 text-white">Careers</td>
                  <td className="border border-gray-300 px-4 py-2 text-white">https://codeblaze.ai/careers</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-2 text-white">Pricing Information</td>
                  <td className="border border-gray-300 px-4 py-2 text-white">https://codeblaze.ai/pricing</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="p-7" />

          <Normal>
            By using our services, you acknowledge that you have read and understood this Privacy Policy and agree to its terms.
          </Normal>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
